import { Component, OnInit, ViewChild } from '@angular/core';
import { UserManagementService } from '../../user-management/user-management.service';
import { Router, NavigationEnd } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { filter } from 'rxjs/operators';

@Component({
    selector: 'user-management-nav',
    templateUrl: './user-management-nav.component.html',
    styleUrls: ['./user-management-nav.component.css'],
    standalone: false
})
export class UserManagementNavComponent implements OnInit {
  @ViewChild('content') content;
  public user: any = { name: 'John Doe' }; // Example user object
  public siteinfo: any;
  sitename: any;
  avatarUrl: string = './assets/images/avathar.jpg'; // Default avatar image
  selectedFile: File | null = null;
  public imageSrc: SafeUrl | null = null; // Property to hold the sanitized image URL


  constructor(private router: Router, private userService: UserManagementService, private sanitizer: DomSanitizer, private http: HttpClient) {}

  ngOnInit(): void {
    this.refreshUserAndSite();
    const allSites = this.userService.getSiteDetail();
    const storedUser = localStorage.getItem('userDetail');
    this.user = storedUser ? JSON.parse(storedUser) : this.userService.getUserDetail();
    this.siteinfo = this.userService.getSiteDetail();
    if (allSites?.length) {
      this.sitename = this.siteinfo[0].site_name;
    }
    const storedAvatar = localStorage.getItem('avatarUrl');
    if (storedAvatar) {
      this.avatarUrl = storedAvatar;
    }
    const user = this.userService.getUserDetail();
    if (user && user.id) {
      this.loadUserImage(user.id);
    } else {
      this.imageSrc = '../../../assets/images/C-E-O.png';
    }
    this.router.events
    .pipe(filter(event => event instanceof NavigationEnd))
    .subscribe(() => {
      this.refreshUserAndSite();
    });
     window.addEventListener('popstate', this.forceImageReloadOnPopState);
  }
ngOnDestroy(): void {
  window.removeEventListener('popstate', this.forceImageReloadOnPopState);
}

forceImageReloadOnPopState = () => {
  this.refreshUserAndSite();
}
  refreshUserAndSite() {
    const allSites = this.userService.getSiteDetail();
    // Always get the latest user from localStorage
    const storedUser = localStorage.getItem('userDetail');
    this.user = storedUser ? JSON.parse(storedUser) : this.userService.getUserDetail();
    this.siteinfo = this.userService.getSiteDetail();
    if (allSites?.length) {
      this.sitename = this.siteinfo[0].site_name;
    }
    if (this.user && this.user.id) {
      // Use the new dynamic endpoint with user_id
      this.loadUserImage(this.user.id);
    } else {
      this.imageSrc = '../../../assets/images/C-E-O.png';
    }
  }

  // Handle file selection
  onImageUpload(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.selectedFile = input.files[0];
      this.uploadImage();
    }
  }

 // Upload the selected image
  loadUserImage(userId: string | number): void {
    // Use the direct user-image endpoint that works without CORS issues
    const imageUrl = `${environment.nodeUrl1}user-image/${userId}?t=${Date.now()}`;
    console.log('Loading user image from URL:', imageUrl);
    console.log('User ID:', userId);
    
    this.http.get(imageUrl, { responseType: 'blob' }).subscribe(
      (blob) => {
        console.log('✅ User image loaded successfully from:', imageUrl);
        console.log('Blob size:', blob.size);
        this.imageSrc = this.sanitizer.bypassSecurityTrustUrl(
          URL.createObjectURL(blob)
        );
      },
      (error) => {
        console.error('Error loading user image:', error);
        console.error('Image URL that failed:', imageUrl);
        // Fallback to default avatar if image not found
        this.imageSrc = '../../../assets/images/C-E-O.png';
      }
    );
  }

  uploadImage(): void {
  if (!this.selectedFile) {
    alert('Please select an image to upload.');
    return;
  }

  const formData = new FormData();
  formData.append('image', this.selectedFile);
  formData.append('user_id', String(this.user.id)); // Use the actual user ID

  const uploadUrl = `${environment.nodeUrl1}upload-image`;

  this.http.post(uploadUrl, formData).subscribe(
    (response: any) => {
      if (response && response.imageUrl) {
        // Extract the filename from the imageUrl
        const urlParts = response.imageUrl.split('/');
        const filename = urlParts[urlParts.length - 1];
        this.user.image = filename;
        this.userService.addUserDetail(this.user);
        localStorage.setItem('userDetail', JSON.stringify(this.user));
        
        // Reload the image with cache-busting
        this.loadUserImage(this.user.id);
        
        alert('Image uploaded successfully!');
        this.refreshUserAndSite();
      } else {
        alert('Image uploaded, but no imageUrl returned.');
      }
    },
    (error) => {
      alert('Failed to upload image.');
    }
  );
}

  logout() {
    this.userService.logout();
    sessionStorage.removeItem('visitedUserManagementSites');
    sessionStorage.removeItem('admin_id');
    // Clear all local storage
    localStorage.clear();
    this.router.navigate(['/login']);
  }
}
